"use client";

import TwoColTable from '@/components/table';
import styles from './_hcp-varies-by-age.module.scss';
import CustomImage from '@/components/image';
import Button from '@/components/button';

export default function HcpDosingVariesByAge() {
  const data = [
    [<>Adults (18 and older) <br/> and children weighing ≥55 kg</>, <>Capsules: 100 mg twice daily< br/> (200 mg per day)</>],
    [<>Children weighing 20 to &lt;55 kg</>, <>Capsules or oral solution: <br /> 50 mg twice daily (100 mg per day)</>],
    [<>Children weighing 10 to &lt;20 kg</>, <>Oral solution: <br /> 25 mg twice daily (50 mg per day)</>]
  ];

  const ageAndWeightData = [
    {
      name: "Age and body weight",
      label: <>Age and<br className="mobile:hidden" /> body weight</>,
      labelMobile: <>Age and body weight</>,
    },
    {
      name: "Recommended dosage",
      label: <>Recommended<br className="mobile:hidden" /> dosage</>,
      labelMobile: <>Recommended dosage</>,
    }
  ];

  return (
    <section className={styles.container}>
      <div className="container">
        <h1>CRENESSITY dosing varies by age and weight<sup>1</sup></h1>
        <TwoColTable
          columnData={[
            ...ageAndWeightData,
          ]}
          data={data}
        >
        </TwoColTable>
        

        <div className={styles.dosing_wrapper}>
          <div className={styles.dosing}>
            <div className={styles.dosing__image}>
              <CustomImage
                src="/images/components/hcp/Dosing_Crenessity-Capsule-Bottle.png"
                width={181}
                height={264}
                priority
                alt=""
              />
            </div>
            <div className={styles.dosing__title}>
              <h2>CRENESSITY is a CYP3A4 substrate¹</h2>
            </div>
            <div className={styles.dosing__list}>
              <ul>
                <li><span>CRENESSITY <Button
                  customClass={`${styles.tooltip_2} !underline text-hcp-eggplant sup-info`}
                  type="tooltip"
                  tooltipData={({
                    maxWidth: '504px',
                    content: <ul>
                      <li>
                        Strong CYP3A4 inducers: Increase CRENESSITY morning and evening dosage 2-fold<sup>1</sup>
                      </li>
                      <li>
                        Moderate CYP3A4 inducers: Increase CRENESSITY evening dosage 2-fold<sup>1</sup>
                      </li>
                    </ul>
                  })}
                  data-gtm-event-category="Action"
                  data-gtm-event-action="Click"
                  data-gtm-event-label="dose should be increased"
                >dose should be increased</Button> when coadministered with a strong or moderate CYP3A4 inducer<sup>1</sup></span></li>
                <li><span>Please refer to the full <Button
                  href="https://www.neurocrine.com/crenessitypi"
                  targetBlank
                  customClass="!underline text-hcp-eggplant"
                  data-gtm-event-category="PDF"
                  data-gtm-event-action="Download"
                  data-gtm-event-label="Prescribing Information"
                >Prescribing Information</Button> for full dosing information and additional considerations for patients taking CYP3A4 inducers or inhibitors</span></li>
              </ul>
            </div>
          </div>
        </div>

        <div className="hcp-callout mx-auto text-center">
          <p className="mx-auto max-w-[710px]">CRENESSITY does not address cortisol deficiency. Patients prescribed CRENESSITY should continue taking GCs.<sup className="!font-normal">1,2</sup></p>
          <p className="mx-auto max-w-[710px]">CRENESSITY should be used alongside GC therapy and has no contraindications with any specific GC used in the treatment of CAH.</p>
        </div>

        <div className={styles.layout_wrapper}>
          <div className={styles.image}>
            <CustomImage
              src="/images/page/hcp/dosing/Dosing_Clock-Icon.svg"
              width={564}
              height={564}
              priority
              alt=""
            />
          </div>
          <div className={styles.text}>
            <h2 className={`h1 ${styles.text__header}`}>Around-the-clock ACTH and androgen reduction</h2>
            <p className={styles.text__body}>When comparing doses, twice-daily dosing led to the greatest reduction of androstenedione.<sup>3</sup><span className="super-asterisc">*</span></p>
            <span className={styles.text__footnote}>
              <span className="hang">*</span>
              <p className={styles.text_footnote}>A phase 2 study compared 50 mg once daily, 100 mg once daily, and 100 mg twice daily.  Main outcomes included change from baseline to day 14 in ACTH, 17-OHP, androstenedione, and testosterone. 100 mg twice daily led to the greatest reductions.<sup>3</sup></p>
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}

